import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import DeleteModalComponent from "../basics/table/DeleteModalComponent";
import MonthDayInputComponent from "../basics/form/MonthDayInputComponent";
import AttendeeFormError from './errors/AttendeeFormError';
import { PriceHelper } from "../../helpers";

class AttendeeCustomSettingsFormComponent extends React.Component {
    constructor(props) {
        super(props);

        let { settings } = props.values;

        this._labels = {
            email: 'show_email',
            phone: 'show_telephone',
            gender: 'show_gender',
            birth_date: 'show_date_of_birth',
            national_insurance_number: 'show_national_registration_number',
            medical_info: 'show_medical_info'
        };
        
        this.state = {
            fields: {
                email: settings?.fields?.email ? settings.fields.email : false,
                phone: settings?.fields?.phone ? settings.fields.phone : false,
                gender: settings?.fields?.gender ? settings.fields.gender : false,
                birth_date: settings?.fields?.birth_date ? settings.fields.birth_date : false,
                national_insurance_number: settings?.fields?.national_insurance_number ? settings.fields.national_insurance_number : false,
                medical_info: settings?.fields?.medical_info ? settings.fields.medical_info : false,
            },
            use_membership: settings.use_membership,
            use_membership_duration: settings.use_membership_duration,
            membership_duration: settings.membership_duration,
            use_membership_start_date: settings.use_membership_start_date,
            membership_start_date: settings.membership_start_date,
            membership_price_currency: settings.membership_price_currency,
            membership_price: settings.membership_price ? PriceHelper.price(settings.membership_price) : null,
            membership_webshop_discount_code: settings.membership_webshop_discount_code,
            use_health_insurance_certificate: settings.use_health_insurance_certificate,
            can_disable_birth_date_field: settings.can_disable_birth_date_field,
            can_disable_national_insurance_number_field: settings.can_disable_national_insurance_number_field
        }

        this.originalValues = this.props.values;
    }

    onChange = (event, custom = null) => {
        let name = event.target.name.replace('settings.', '');
        if (event.target.type === "checkbox" && this.props.values.settings[name] && this.originalValues.settings[name] && this.state.deleteRow !== name) {
            DeleteModalComponent.openDeleteModal(event, name, this);
            this.setState({ currentEvent: { ...event } })
        } else {
            if (custom != null) {
                custom();
            }

            this.props.handleChange(event);
        }
    };

    changeConfirmModal = () => {
        this.state.currentEvent.currentTarget.click();
        this.setState({ showDeleteModal: false, deleteRow: null, currentEvent: null })
    }

    render() {
        return (
            <Form.Group className="custom-settings">
                <Row>
                    <Col xs={12}>
                        <FormattedMessage id="CMS.Attendee.Form.fields">
                            {(value) => <Form.Label>{value}</Form.Label>}
                        </FormattedMessage>
                    </Col>

                    <Form.Group as={Col} xs={12}>
                        <Row>
                            {Object.keys(this.state.fields).map(field => (
                                <Col xs={12}>
                                    <Form.Check type="switch" id={'custom-switch-' + field} name={"settings.fields." + field}
                                        label={this._labels[field]} className="mb-1" checked={this.state.fields[field]}
                                        disabled={(field === 'birth_date' && !this.state.can_disable_birth_date_field) || (field === 'national_insurance_number' && !this.state.can_disable_national_insurance_number_field)}
                                        onChange={event => this.onChange(event, () => {
                                            let fields = this.state.fields;
                                            fields[field] = !fields[field];
                                            this.setState({ fields: fields })
                                        })}
                                    />
                                    {field === 'birth_date' && !this.props.values.settings.can_disable_birth_date_field && (
                                        <FormattedMessage id="CMS.Attendee.Form.settings.info.birth_date_field.disabled">
                                            {values => <p className="input-info text-warning">{values}</p>}
                                        </FormattedMessage>
                                    )}
                                    {field === 'national_insurance_number' && !this.props.values.settings.can_disable_national_insurance_number_field && (
                                        <FormattedMessage id="CMS.Attendee.Form.settings.info.national_insurance_number_field.disabled">
                                            {values => <p className="input-info text-warning">{values}</p>}
                                        </FormattedMessage>
                                    )}

                                    <FormattedMessage id={"CMS.Attendee.Form.settings.field." + field + '_info'}>
                                        {(values) => <p className="input-info">{values}</p>}
                                    </FormattedMessage>
                                </Col>
                            ))}
                        </Row>
                    </Form.Group>
                </Row>

                <Row>
                    <Col xs={12}>
                        <FormattedMessage id="CMS.Attendee.Form.settings">
                            {(value) => <Form.Label>{value}</Form.Label>}
                        </FormattedMessage>
                    </Col>

                    {/* Use membership */}
                    <Form.Group as={Col} xs={12}>
                        <Row>
                            <Col xs={12}>
                                <Form.Check
                                    type="switch"
                                    id="custom-switch-use-membership"
                                    label="use_attendee_membership"
                                    name="settings.use_membership"
                                    onChange={event => this.onChange(event, () => this.setState({ use_membership: !this.state.use_membership, use_membership_duration: false, membership_duration: null, use_membership_start_date: false, membership_start_date: null }, () => {
                                        this.props.values.settings.use_membership_duration = false;
                                        delete this.props.values.settings.membership_duration;
                                        this.props.values.settings.use_membership_start_date = false;
                                        delete this.props.values.settings.membership_start_date;
                                    }))}
                                    className="mb-1"
                                    checked={this.state.use_membership}
                                />
                            </Col>

                            {this.state.use_membership ?
                                <>
                                    <Form.Group className="subsettings">
                                        <Row>
                                            <Col md={12}>
                                                <Form.Check type="switch" label="attendee_membership_duration" className="mb-1 is-invalid"
                                                    id="custom-switch-use_membership_duration"
                                                    name="settings.use_membership_duration"
                                                    onChange={event => this.onChange(event, () => this.setState({ use_membership_duration: !this.state.use_membership_duration }, () => {
                                                        delete this.props.values.settings.membership_duration;

                                                        if (this.state.use_membership_duration) {
                                                            this.setState({ use_membership_start_date: false, membership_start_date: null }, () => {
                                                                this.props.values.settings.use_membership_start_date = false;
                                                                delete this.props.values.settings.membership_start_date;
                                                            })
                                                        }
                                                    }))}
                                                    checked={this.state.use_membership_duration}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {this.props.errors.settings?.use_membership_duration && (
                                                        <AttendeeFormError error={this.props.errors.settings.use_membership_duration} />
                                                    )}
                                                </Form.Control.Feedback>

                                            </Col>
                                            {this.state.use_membership_duration ?
                                                <Form.Group className="subsettings sub">
                                                    <Row>
                                                        <Col md={12}>
                                                            <InputGroup className="no-suffix">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrependEyecatcherWidth">months</InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control type="text" name="settings.membership_duration"
                                                                    aria-describedby="membership_duration"
                                                                    onChange={this.onChange}
                                                                    isInvalid={this.props.errors.settings != null && this.props.errors.settings.membership_duration}
                                                                    value={this.props.values.settings.membership_duration}
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {this.props.errors.settings != null && this.props.errors.settings.membership_duration && (
                                                                        <AttendeeFormError error={this.props.errors.settings.membership_duration} />
                                                                    )}
                                                                </Form.Control.Feedback>
                                                            </InputGroup>
                                                            <FormattedMessage id={"CMS.Attendee.Form.settings.info.months"}>
                                                                {(values) => <p className="input-info">{values}</p>}
                                                            </FormattedMessage>
                                                        </Col>
                                                    </Row>
                                                </Form.Group> :
                                                null}
                                            <Col md={12}>
                                                <FormattedMessage id={"CMS.Attendee.Form.settings.info.membership_duration"}>
                                                    {(values) => <p className="input-info">{values}</p>}
                                                </FormattedMessage>
                                            </Col>

                                            <Col md={12}>
                                                <Form.Check type="switch" label="attendee_membership_start_date" className="mb-1 is-invalid"
                                                    name="settings.use_membership_start_date" id="custom-switch-use_membership_start_date"
                                                    onChange={event => this.onChange(event, () => this.setState({ use_membership_start_date: !this.state.use_membership_start_date }, () => {
                                                        this.props.values.settings.membership_start_date = null;

                                                        if (this.state.use_membership_start_date) {
                                                            this.setState({ use_membership_duration: false, membership_duration: null, self_registration: false }, () => {
                                                                this.props.values.settings.self_registration = false;
                                                                this.props.values.settings.use_membership_duration = false;
                                                                delete this.props.values.settings.membership_duration;
                                                            })
                                                        }
                                                    }))}
                                                    checked={this.state.use_membership_start_date}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {this.props.errors.settings?.use_membership_start_date && (
                                                        <AttendeeFormError error={this.props.errors.settings.use_membership_start_date} />
                                                    )}
                                                </Form.Control.Feedback>

                                            </Col>
                                            {this.state.use_membership_start_date ?
                                                <Form.Group className="subsettings sub">
                                                    <Row>
                                                        <Col md={12}>
                                                            <MonthDayInputComponent name="settings.membership_start_date"
                                                                value={this.props.values.settings.membership_start_date}
                                                                onChange={value => this.props.handleChange('settings.membership_start_date')(value)}
                                                                isInvalid={!!(this.props.errors.settings != null && this.props.errors.settings.membership_start_date)}
                                                            />
                                                            {this.props.errors.settings != null && this.props.errors.settings.membership_start_date && (
                                                                <Form.Control.Feedback type="invalid" className="d-block">
                                                                    <AttendeeFormError error={this.props.errors.settings.membership_start_date} />
                                                                </Form.Control.Feedback>
                                                            )}
                                                            <FormattedMessage id={"CMS.Attendee.Form.settings.info.date"}>
                                                                {(values) => <p className="input-info">{values}</p>}
                                                            </FormattedMessage>
                                                        </Col>
                                                    </Row>
                                                </Form.Group> :
                                                null}
                                            <Col md={12}>
                                                <FormattedMessage id={"CMS.Attendee.Form.settings.info.use_membership_start_date"}>
                                                    {(values) => <p className="input-info">{values}</p>}
                                                </FormattedMessage>
                                            </Col>

                                            <Col md={12}>
                                                <InputGroup className="large">
                                                    <InputGroup.Prepend>
                                                        <InputGroup.Text id="inputGroupPrependEyecatcherWidth">attendee_membership_price</InputGroup.Text>
                                                    </InputGroup.Prepend>
                                                    <div className="form-control-currency-disabled">
                                                        <Form.Control as="select" name="settings.membership_price_currency" className="form-control-xs form-control-currency"
                                                            disabled aria-describedby="membership_price_currency"
                                                            onChange={this.onChange}
                                                            isInvalid={this.props.errors.settings != null && this.props.errors.settings.membership_price_currency}
                                                            value={this.props.values.settings.membership_price_currency}
                                                        >
                                                            {Object.keys(PriceHelper.getCurrencyList()).map(currency => (
                                                                <option value={currency} key={currency} dangerouslySetInnerHTML={{ __html: PriceHelper.getCurrencySign(currency) }} />
                                                            ))}
                                                        </Form.Control>
                                                    </div>
                                                    <Form.Control type="text" name="settings.membership_price"
                                                        aria-describedby="membership_price"
                                                        onChange={this.onChange}
                                                        isInvalid={this.props.errors.settings != null && this.props.errors.settings.membership_price}
                                                        value={this.props.values.settings.membership_price}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {this.props.errors.settings != null && this.props.errors.settings.membership_price && (
                                                            <AttendeeFormError error={this.props.errors.settings.membership_price} />
                                                        )}
                                                    </Form.Control.Feedback>
                                                </InputGroup>
                                                <FormattedMessage id="CMS.Attendee.Form.settings.info.membership_price">
                                                    {(values) => <p className="input-info">{values}</p>}
                                                </FormattedMessage>
                                            </Col>

                                            <Col md={12}>
                                                <Form.Check type="switch" label="use_attendee_membership_webshop_discount_code" className="mb-1"
                                                    id="custom-switch-membership_webshop_discount_code"
                                                    name="settings.membership_webshop_discount_code"
                                                    onChange={event => this.onChange(event, () => this.setState({ membership_webshop_discount_code: !this.state.membership_webshop_discount_code }))}
                                                    checked={this.state.membership_webshop_discount_code}
                                                />
                                                <FormattedMessage id={"CMS.Attendee.Form.settings.info.membership_webshop_discount_code"}>
                                                    {(values) => <p className="input-info">{values}</p>}
                                                </FormattedMessage>
                                            </Col>

                                            <Col md={12}>
                                                <Form.Check type="switch" label="use_attendee_membership_health_insurance_certificate" className="mb-1"
                                                    id="custom-switch-use_health_insurance_certificate"
                                                    name="settings.use_health_insurance_certificate"
                                                    onChange={event => this.onChange(event, () => this.setState({ use_health_insurance_certificate: !this.state.use_health_insurance_certificate }))}
                                                    checked={this.state.use_health_insurance_certificate}
                                                />
                                                <FormattedMessage id={"CMS.Attendee.Form.settings.info.use_health_insurance_certificate"}>
                                                    {(values) => <p className="input-info">{values}</p>}
                                                </FormattedMessage>
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </>
                                : null}

                            <Col>
                                <FormattedMessage id={"CMS.Attendee.Form.settings.info.use_membership"}>
                                    {(values) => <p className="input-info">{values}</p>}
                                </FormattedMessage>
                            </Col>
                        </Row>
                    </Form.Group>
                </Row>

                <DeleteModalComponent parent={this}
                    title="CMS.Attendee.Form.setting.delete.title" text="CMS.Attendee.Form.setting.delete.text"
                    buttons={{ confirm: { text: 'Default.confirm', icon: 'check' } }}
                    customDeleteRowFunction={this.changeConfirmModal}
                    customCloseModalFunction={() => this.setState({ showDeleteModal: false, deleteRow: null })}
                />
            </Form.Group>
        );
    }
}

export default AttendeeCustomSettingsFormComponent;